/* eslint-disable default-case, no-param-reassign */
/*
 *
 * Login reducer
 *
 */

import produce from 'immer';

import {
  CHANGE_INPUT,
  FOCUS_INPUT,
  RESET_CONSENT,
  RESET_INPUTS,
  RESET_LOGIN,
  RESET_TOTP,
  SET_IS_FIRST_PRE_AUTH_VISIT,
  TOGGLE_DRAWER,
  UPDATE_MFA_OPTIONS,
  VALIDATION_ERROR,
} from './constants';

/*
  TODO: when consentsNeeded values are fetched, set consent form
        values to their opposites in reducer case
*/
export const initialState = {
  consentsNeeded: {
    electronicCommunicationsPolicy: true,
    estatementPolicy: true,
    privacyPolicy: true,
    termsOfUse: true,
  },
  errors: {
    bannerError: false,
    serviceError: false,
  },
  focus: { pin: 0 },
  formErrors: {
    totp: { passcode: '' },
    welcome: { lastFourSsn: '', loanNumber: '' },
  },
  forms: {
    consent: {
      electronicCommunicationsPolicy: false,
      estatementPolicy: false,
      privacyPolicy: false,
      termsOfUse: false,
    },
    login: {
      password: '',
      username: '',
    },
    mfa: { selectedOption: '' },
    pin: { pin: '' },
    totp: { passcode: '' },
    welcome: { lastFourSsn: '', loanNumber: '' },
  },
  isDrawerOpen: false,
  isFirstPreAuthVisit: true,
  mfaOptions: [],
  success: false,
};

const loginReducer = produce((draft, { payload, type }) => {
  switch (type) {
    case CHANGE_INPUT: {
      const { field, form, value } = payload;
      draft.forms[form][field] = value;
      if (draft.formErrors[form]) {
        draft.formErrors[form][field] = '';
      }
      break;
    }
    case FOCUS_INPUT: {
      const { field } = payload;
      draft.focus[field] = Number(!draft.focus[field]);
      break;
    }
    case RESET_INPUTS: {
      draft.forms = initialState.forms;
      draft.formErrors = initialState.formErrors;
      break;
    }
    case RESET_LOGIN: {
      draft.forms.login = initialState.forms.login;
      break;
    }
    case RESET_CONSENT: {
      draft.errors.serviceError = initialState.errors.serviceError;
      draft.forms.consent = initialState.forms.consent;
      break;
    }
    case RESET_TOTP: {
      draft.errors.serviceError = initialState.errors.serviceError;
      draft.formErrors = initialState.formErrors;
      draft.forms.totp = initialState.forms.totp;
      break;
    }
    case SET_IS_FIRST_PRE_AUTH_VISIT: {
      draft.isFirstPreAuthVisit = !draft.isFirstPreAuthVisit;
      break;
    }
    case TOGGLE_DRAWER: {
      const { drawerState } = payload;
      draft.isDrawerOpen = drawerState;
      break;
    }
    case UPDATE_MFA_OPTIONS: {
      const { mfaOptions } = payload;
      draft.mfaOptions = mfaOptions;
      draft.forms.mfa.selectedOption = mfaOptions[0].name;
      break;
    }
    case VALIDATION_ERROR: {
      const { error, field, form } = payload;
      draft.formErrors[form][field] = error;
      break;
    }
  }
}, initialState);

export default loginReducer;
